import { Button, Carousel, Typography,Empty} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useSelector } from "react-redux";
import { getNotifications } from "./service";
import Loader from "../../shared/loader";
import AppAlert from "../../shared/appAlert";
const { Paragraph } = Typography;
const WalletType = process.env.REACT_APP_WALLET_TYPE;

const RecentCarousel = () => {
  const customerInfo = useSelector((store) => store.userConfig.userProfileInfo);
  const[cardsData,setCardData] = useState([]);
  const[errorMessage,setErrorMessage] = useState(null);
  const[loader,setLoader] = useState(false);
  useEffect(() =>{
    getNotificationsDetails();
  },[])
  const getNotificationsDetails = async () => {
    try {
      setLoader(true);
      let response = await getNotifications('Notification/payments/notifications',customerInfo?.id,WalletType === 'non_custodial'?'Web3payments':'payments');
      setCardData(response);
    }
    catch (error) {
      setErrorMessage(error);
    }
    finally{
      setLoader(false);
    }
  }

  const carouselRef = useRef(null);

  const handlePrev = () => {
    carouselRef.current.prev();
  };

  const handleNext = () => {
    carouselRef.current.next();
  };

  return (
    <div className="">
             {loader && <Loader/>}
             {errorMessage && (
            <div className="alert-flex" style={{ width: "100%" }}>
                <AppAlert
                    className="w-100 "
                    type="warning"
                    description={errorMessage}
                    showIcon
                />
                <span className="icon sm alert-close" onClick={() => setErrorMessage(null)}></span>
            </div>
        )}
     { !loader && <div className="p-relative">
      <Carousel
      className={`${cardsData?.length !== 0 && "carosel-width" }`}
        ref={carouselRef}
        dots={false}
        slidesToShow={1}
        infinite={false}
        responsive={[
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ]}
      >
        {cardsData?.length === 0 && !loader && <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No Data"
              ></Empty>}
        {cardsData?.map((item, index) => (
          <div className="slide-card" key={index}>
            <div className="icon-bg bg-green">
            <span className="icon md notifyIcon deposit crypto"></span>
            </div>
           <div>
           <Paragraph className="slide-card-description">
               {item.actionBy}
            </Paragraph>
           <Paragraph className="slide-card-label">
              {item.message}
            </Paragraph>

           </div>
          </div>
        ))}
      </Carousel>
     {cardsData?.length !== 0 && <div className="slide-btn-right">
      <Button
          type="primary"
          shape="circle"
          icon={cardsData?.length > 1 ? <LeftOutlined /> : null}
          style={{ marginRight: "12px" }}
          onClick={handlePrev}
        />
        <Button
          type="primary"
          shape="circle"
          icon={cardsData?.length > 1 ? <RightOutlined /> : null}
          onClick={handleNext}
          disabled={cardsData?.length === 0}
        />
      </div>}
      </div>}
    </div>
  );
};

export default RecentCarousel;
